import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCausesCondictionsChartsDataContext } from './hooks/useCausesCondictionsChartsDataContext';

export const ConfirmationByComplementaryExamination = () => {
    const { chartData } = useCausesCondictionsChartsDataContext();


    return (
        <SimpleBars
            title={'Local de Ocorrência'}
            horizontal={false}
            subtitles={chartData?.confirmationByComplementaryExamination?.map((item) => item.description)}
            values={chartData?.confirmationByComplementaryExamination?.map((item) => item.total  ||  0)}
        />
    );
};
